export default __webpack_public_path__ + "static/Wisdomlogo-f04d17c877babc8d7b3e1b61256de13b.png";